export function ifSmallThenElse(smallProp, elseProp) {
    return function (_a) {
        var size = _a.size, $size = _a.$size;
        return size === 'S' || $size === 'S' ? smallProp : elseProp;
    };
}
//# sourceMappingURL=styled-utils.js.map